import React from 'react';

import s from './styles.module.css';

interface IAvatarProps {
  line1: React.ReactNode;
  line2: React.ReactNode;
}

const TwoLineCell = ({ line1, line2 }: IAvatarProps) => (
  <div className={s.twoLine}>
    <div className={s.line1}>{line1}</div>
    <div className={s.line2}>{line2}</div>
  </div>
);

export { TwoLineCell };
